/* eslint-disable */
export default {
  forward: 'Lähetä edelleen',
  reply: 'Vastaa',
  ignore: 'Ohita',
  toVoicemail: 'Vastaajaan',
  answer: 'Vastaa',
  answerAndEnd: 'Vastaa ja lopeta',
  answerAndHold: 'Vastaa ja aseta pitoon',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"answerAndEnd"@#@ @source: @#@"Answer & End"@#@
// @key: @#@"answerAndHold"@#@ @source: @#@"Answer & Hold"@#@
